import {DURATION} from "./constants";

const initSpots = ( yandexMapHelper ) => {
	const spotsManager = yandexMapHelper.createObjectManager( `spots-manager`, {} );
	
	const spotBalloonWrapperClass = `spot-balloon-wrapper`;
	const spotBalloonWrapperSelector = `div.${spotBalloonWrapperClass}`;
	
	Array.from( yandexMapHelper.component.querySelectorAll( `ul.spots > li` ) )
		.forEach(
			( item ) => {
				let spotComlexName = item.dataset.spotComplexName;
				const spotComlexNameMatch = item.dataset.spotComplexName
					.match(/.*[«|'|"](?<name>.+)[»|'|"].?/);
				
				if ( spotComlexNameMatch && spotComlexNameMatch.groups )
				{
					spotComlexName = spotComlexNameMatch.groups.name
						.split( /\s/ )
						.map( ( word, index ) => {
							return index === 0
								? word
								: word.toLowerCase();
						} )
						.join( ` ` );
				}
				
				const spotProps = {
					type: `Feature`,
					id: item.dataset.spotId,
					geometry: {
						type: `Point`,
						coordinates: [item.dataset.spotLatitude, item.dataset.spotLongitude],
					},
					properties: {
						isSpot: true,
					},
					options: {
						iconLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
							`<div class='spot-icon-wrapper' data-spot-id='${item.dataset.spotId}'>
								<div class='spot'>
									<div class='icon-wrapper'>
										<div class='img-wrapper'>
											<div class='img' style='background-image: url(${item.dataset.spotIcon});'>
											</div>
										</div>
									</div>
								</div>
							</div>`,
							{
								build() {
									this.constructor.superclass.build.call( this );
									
									const iconWrapper = this.getElement().querySelector( `div.spot-icon-wrapper` );
									const icon = this.getElement().querySelector( `div.icon-wrapper` );
									
									if ( iconWrapper && icon )
									{
										const width = icon.offsetWidth;
										const height = icon.offsetHeight;
										
										const shapeCoordinates = [
											[width / -2, -1 * height],
											[width / 2, 0],
										];
										
										const shapeRectangle = {
											type: `Rectangle`,
											coordinates: shapeCoordinates,
										};
										
										this.getData().options.set( `shape`, shapeRectangle );
										
										iconWrapper.style.setProperty( `position`, `absolute` );
										iconWrapper.style.setProperty( `left`, `${width / -2}px` );
										iconWrapper.style.setProperty( `top`, `${-1 * height}px` );
									}
								}
							}
						),
						
						hideIconOnBalloonOpen: true,
						balloonShadow: false,
						balloonPanelMaxMapArea: 0,
						balloonLayout: yandexMapHelper.ymaps.templateLayoutFactory.createClass(
							`<div class='${spotBalloonWrapperClass}' data-spot-id='${item.dataset.spotId}'>
								<div class='spot'>
									<div class='icon-wrapper'>
										<div class='img-wrapper'>
											<div class='img' style='background-image: url(${item.dataset.spotIcon});'>
											</div>
										</div>
									</div>
									<div class='info-wrapper'>
										<h3>${spotComlexName}</h3>
										<p>${item.dataset.spotAreaName}</p>
									</div>
								</div>
							</div>`,
							{
								build() {
									this.constructor.superclass.build.call( this );
									
									const spotWrapper = this.getElement().querySelector( spotBalloonWrapperSelector );
									const iconWrapper = this.getElement().querySelector( `${spotBalloonWrapperSelector} div.icon-wrapper` );
									const spot = this.getElement().querySelector( `${spotBalloonWrapperSelector} div.spot` );
									
									if ( iconWrapper && spot )
									{
										const iconWidth = iconWrapper.offsetWidth;
										const spotWidth = spot.offsetWidth;
										const height = spot.offsetHeight;
										
										const shapeCoordinates = [
											[iconWidth / -2, -1 * height],
											[(spotWidth - iconWidth / 2), 0]
										];
										
										const shapeRectangle = {
											type: `Rectangle`,
											coordinates: shapeCoordinates,
										};
										
										this.getData().options.set( `shape`, shapeRectangle );
										
										spotWrapper.style.setProperty( `position`, `absolute` );
										spotWrapper.style.setProperty( `left`, `${iconWidth / -2}px` );
										spotWrapper.style.setProperty( `top`, `${-1 * height}px` );
										
										const balloonClickHandler = () => {
											if ( yandexMapHelper.isTouch() )
											{
												spotWrapper.removeEventListener( `click`, balloonClickHandler );
												yandexMapHelper.closeBalloon();
											}
										};
										
										/* setTimeout добавлен из-за глюков яндекса - быстрого закрытия балуна */
										setTimeout(
											() => {
												spotWrapper.addEventListener( `click`, balloonClickHandler );
											},
											100
										);
									}
								}
							}
						),
						
						zIndex: 3,
					}
				};
				
				spotsManager.add( spotProps );
			}
		);
	
	spotsManager.events.add(
		`mouseenter`,
		( evt ) => {
			const currentObjectId = evt.get( `objectId` );
			
			spotsManager.objects.balloon.open( currentObjectId );
		}
	);
	
	yandexMapHelper.yandexMap.balloon.events.add(
		`mouseleave`,
		( evt ) => {
			if ( yandexMapHelper.yandexMap.balloon.getData().object.properties.isSpot )
			{
				/* таймаут добавлен из-за появлением метки под курсором и циклическим открытием балуна */
				setTimeout(
					() => {
						yandexMapHelper.closeBalloon();
					},
					100
				);
			}
		}
	);
	
	const bounds = spotsManager.getBounds();
	if ( bounds ) {
		yandexMapHelper.yandexMap.setBounds(
			bounds,
			{checkZoomRange: true, duration: DURATION, useMapMargin: true}
		).then(
			() => {
				yandexMapHelper.initZoom = yandexMapHelper.yandexMap.getZoom();
				yandexMapHelper.initCenter = yandexMapHelper.yandexMap.getCenter();
			}
		);
	}
};

export {
	initSpots,
};
